import { h } from 'preact'; /** @jsx h */

import './EmptyCart.scss';

const EmptyCart = () => {
    return (
        <div className="ws-empty-cart">
            {/* UserPanel - Empty cart */}
            <h4 className="ws-empty-cart-title">Du har ingen varer i handlevognen</h4>
            <a className="ws-empty-cart-btn" href="/nettbutikk">
                Se alle produkter
            </a>
        </div>
    );
};

export default EmptyCart;
